import type { ReactNode } from "react";

export function TestShell({ children }: { children: ReactNode }) {
  return <div className="mx-auto flex min-h-svh w-full max-w-4xl flex-col px-4 pb-10 pt-0 sm:px-6">{children}</div>;
}
